import React from "react";
import AboutUs1 from "./AboutUs1";
import Navbar from "../NavBar/Navbar";
// import Footer from "../Footer/Footer";
import AboutUs2 from "./AboutUs2";
import AboutUs3 from "./AboutUs3";
import AboutUs4 from "./AboutUs4";
import AboutUs5 from "./AboutUs5";
import Home9 from "../Home/Home9";
const AboutUsMain = () => {
    return (
        <>
        <Navbar />
        <AboutUs1 />
        {/* <AboutUs2 /> */}
        <AboutUs3 />    
        {/* <AboutUs4 /> */}
        <AboutUs5 />
        <Home9 />
        {/* <Footer /> */}
        </>
    )
}

export default AboutUsMain;